







































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { BSpinner } from "bootstrap-vue";
import Swal from 'sweetalert2'

import { applyTheme, ThemeConfig } from "@/helpers/themeHelper";

interface NavigatorShare extends Navigator {
    canShare?: (data?: { files?: File[] }) => boolean;
    share?: (data: { title?: string; text?: string; files?: File[] }) => Promise<void>;
}


@Component({
  components: {
    BSpinner,
  },
})
export default class LabLogin extends Vue {
  @Prop(String) readonly publicId!: string;
  private themeConfig: ThemeConfig | null = null;
  phone = "";
  requisition = "";
  otpCode = "";
  ua = navigator.userAgent.toLowerCase();
  //showCodeInput = false;
  birth = {
    year: "",
    years: Array<string>(),
    month: "",
    monthDays: Array<string>(),
    day: "",
    date: "",
  };
  config = {
    loginMethod: "DOB_PHONE",
    requires2FA: false,
    entityLogoId: "",
    lang: "EN",
    theme: {},
    disclaimer: {},
    showEntityName:true
  };
  @Watch("birth", { deep: true })
  onBirthChanged(birth) {
    const birthdate = this.$moment([birth.year, birth.month, birth.day]);
    this.birth.date = birthdate.isValid() ? birthdate.format("YYYY-MM-DD") : "";
  }
  async login() {

    if (!this.validateLoginInputs(this.config, this)) return;

    const accepted = await this.showPrivacyPolicy();
    if (!accepted) return;

    // SET FORM DATA
    const params = new FormData();
    params.append("publicId", this.publicId);
    params.append("birthdate", this.birth.date);
    if (this.phone)
      params.append("phone", this.phone);
    if (this.requisition)
      params.append("requisition", this.requisition);
    params.append("otpCode", this.otpCode);
    // GET LAB VISIT ASYNC
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { data } = await Vue.axios.post("labs/visit", params);

      if (data.message === "CODE_SENT") {
        const result = await this.askForCodeAndValidate(this);

        if (result.isConfirmed && result.value) {
          const visitData = result.value;

          if (visitData.header?.IsPdfResult) {
            visitData.header.ShowEntityName= this.config.showEntityName;
            this.$router.push({ name: "LabResults", replace: true, params: { visit: visitData } });
          } else {
            this.$router.push({ name: "LabResult", replace: true, params: { visit: visitData } });
          }
        }

        return;
      }

      if (data.header.IsPdfResult) {
        data.header.ShowEntityName= this.config.showEntityName;
        this.$router.push({
          name: "LabResults",
          replace: true,
          params: { visit: data }
        });
      } else {
        this.$router.push({
          name: "LabResult",
          replace: true,
          params: { visit: data },
        });
      }

    } catch (error) {
      const message = String(error.response?.data || "");
      const notFound = message.includes("LAB_VISIT_NOT_FOUND");

      let innerText = "";

      if (notFound) {
        switch (this.config.loginMethod) {
          case "DOB_PHONE":
            innerText = this.$t("INCORRECT PHONE OR BIRTHDATE") as string;
            break;
          case "DOB_RQNUM":
            innerText = this.$t("INCORRECT REQUISITION OR BIRTHDATE") as string;
            break;
          case "DOB_2FACT":
            innerText = this.$t("INCORRECT BIRTHDATE") as string;
            break;
          default:
            innerText = this.$t("INVALID LOGIN METHOD") as string;
            break;
        }
      } else {
        innerText = this.$t("An error has occurred") as string;
      }

      const html = `
        <div style="text-align:center;">
            <i class="fas fa-exclamation-triangle fa-3x" style="color:#dc3545; margin-bottom:15px;"></i>
        </div>
        <div class='wm-fw-500 wm-fc-2 text-center'>${innerText}</div>
    `;

      await Swal.fire({
        // icon: "error",
        title: "WaitingMed",
        html,
        confirmButtonText: this.$t("Continue") as string,
        confirmButtonColor: "#3085d6"
      });
    }
    finally {
      this.$store.commit("main/SET_LOADING", false);
    }
    //
  }

  async askForCodeAndValidate(context) {
    return await Swal.fire({
      title: this.$t("Verification") as string,
      html: `
      <div style="text-align:center;">
        <i class="fas fa-lock fa-3x" style="color:#3085d6; margin-bottom:15px;"></i>
        <p>${this.$t(
        "A verification code has been sent to your email or phone number."
      )}<br><br>${this.$t(
        "Please check your inbox or SMS/WhatsApp messages and enter the code below to continue."
      )}</p>
      </div>
    `,
      input: "number",
      inputLabel: this.$t("Enter verification code") as string,
      inputValue: context.otpCode || "",
      showCancelButton: true,
      confirmButtonText: this.$t("Verify") as string,
      cancelButtonText: this.$t("Cancel") as string,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async (code) => {
        if (!code) {
          Swal.showValidationMessage(this.$t("You need to enter the code!") as string);
          return false;
        }

        try {
          const retryParams = new FormData();
          retryParams.append("publicId", context.publicId);
          retryParams.append("birthdate", context.birth.date);
          if (context.phone) retryParams.append("phone", context.phone);
          if (context.requisition) retryParams.append("requisition", context.requisition);
          retryParams.append("otpCode", code);

          const { data } = await Vue.axios.post("labs/visit", retryParams);

          if (data.message === "CODE_INVALID") {
            Swal.showValidationMessage(this.$t("Incorrect code. Please try again.") as string);
            return false;
          }

          context.otpCode = code;
          return data;
        } catch {
          Swal.showValidationMessage(this.$t("Error validating code. Please try again.") as string);
          return false;
        }
      }
    });
  }



  validateLoginInputs(config, form) {
    const { loginMethod } = config;
    const { birth, phone, requisition } = form;

    if (!birth?.date) return false;

    const requirements = {
      DOB_PHONE: !!phone,
      DOB_RQNUM: !!requisition,
      DOB_2FACT: true
    };

    return requirements[loginMethod] ?? false;
  }


  async getConfig() {
    // SET FORM DATA
    const params = new FormData();
    params.append("publicId", this.publicId);

    // START LOADING
    this.$store.commit("main/SET_LOADING", true);

    try {

      const { data: loginData } = await Vue.axios.post("labs/login/Config", params);

      this.config = Object.assign({}, this.config, loginData.config);

      const lang = (this.config.lang || "EN").toLowerCase();
      this.$store.commit("main/SET_LANG", lang);
      this.$i18n.locale = lang;

      this.getEntityLogo();

      const { data: pageData } = await Vue.axios.post("labs/page/Config", params);

      if (pageData?.disclaimer) {
        this.config.disclaimer = pageData.disclaimer;
      }

      if(pageData?.hideEntityName){
         this.config.showEntityName = !pageData?.hideEntityName;
      }

      if (pageData?.theme) {

        this.config.theme = pageData.theme;

        this.themeConfig = pageData;

        if (pageData.theme.isActive) {
          applyTheme(this.themeConfig);
          sessionStorage.setItem("themeConfig", JSON.stringify(this.themeConfig));
        } else {
          sessionStorage.removeItem("themeConfig");
        }
      } else {
        sessionStorage.removeItem("themeConfig");
      }

    } catch (error) {
      console.error("Error loading configuration:", error);

      this.$modal.show("dialog", {
        title: "WaitingMed",
        text: "AN ERROR HAS OCCURRED",
      });

    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }



  async getConfig2() {
    // SET FORM DATA
    const params = new FormData();
    params.append("publicId", this.publicId);

    // GET CONFIG ASYNC
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { data } = await Vue.axios.post("labs/login/Config", params);

      this.config = Object.assign({}, this.config, data.config);

      const lang = (this.config.lang || "EN").toLowerCase();
      this.$store.commit("main/SET_LANG", lang);
      this.$i18n.locale = lang;

      this.getEntityLogo();

    } catch (error) {

      this.$modal.show("dialog", {
        title: "WaitingMed",
        text: "AN ERROR HAS OCCURRED",
      });

    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }


  }

  async getEntityLogo() {
    if (!this.config.entityLogoId) return;
    const params = new FormData();
    params.append("id", this.config.entityLogoId);
    const { data } = await Vue.axios.post("labs/content", params, {
      responseType: "blob",
    });
    const blob = new Blob([data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const logoEl = document.querySelector<HTMLImageElement>("#entity-logo");
    if (logoEl) {
      logoEl.src = url;
    }
  }

  async showPrivacyPolicy() {
    try {
      /*
        const lang = (this.config?.lang || "en").toLowerCase();

        const response = await fetch(`/terms-and-conditions-${lang}.html`);

        if (!response.ok) throw new Error("File not found");
        const html = await response.text();
*/

      const lang = (this.config?.lang || "en").toLowerCase();
      const key = lang.toUpperCase();

      let html: string;

      const localHtml = this.config?.disclaimer?.[key];
      if (localHtml) {
        html = localHtml;
      }
      else {
        const res = await fetch(`/terms-and-conditions-${lang}.html`);

        if (!res.ok) {
          throw new Error(`File not found (${lang})`);
        }

        html = await res.text();
      }

      const result = await Swal.fire({
        title: this.$t("Terms and Conditions") as string,
        html: `
    <div style="text-align:center;">
      <i class="fas fa-file-contract fa-3x" style="color:#3085d6; margin-bottom:15px;"></i>
    </div>
    <div style="text-align:left; max-height:300px; overflow-y:auto; font-size:14px; line-height:1.5;">
      ${html}
    </div>
  `,
        showCancelButton: true,
        confirmButtonText: this.$t("I Agree") as string,
        cancelButtonText: this.$t("Cancel") as string,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#aaa",
        width: 600
      });


      return result.isConfirmed;
    } catch (err) {
      console.error("Error loading Terms and Conditions:", err);
      await Swal.fire("Error", "Unable to load Terms and Conditions.", "error");
      return false;
    }
  }

  setBirthMonthDays() {
    this.birth.monthDays = [];
    const { year, month } = this.birth;
    if (year === "" || month === "") {
      return;
    }
    const days = this.$moment([year, month]).daysInMonth();
    for (let day = 1; day <= days; day++) {
      this.birth.monthDays.push(day.toString());
    }
  }
  setBirthYearsBK() {
    let year = 1900;
    while (year <= this.$moment().year()) {
      this.birth.years.push(year.toString());
      year++;
    }
  }

  setBirthYears() {
  this.birth.years = [];
  let year = this.$moment().year();

  while (year >= 1900) {
    this.birth.years.push(year.toString());
    year--;
  }
}


  get currentLangLabel() {
    return this.config.lang.toUpperCase() === "EN" ? "ES" : "EN";
  }

  toggleLanguage() {
    const newLang = this.config.lang.toUpperCase() === "EN" ? "ES" : "EN";
    this.config.lang = newLang;
    this.$store.commit("main/SET_LANG", newLang.toLowerCase());
    this.$i18n.locale = newLang.toLowerCase();
  }

  applyThemeBK(theme) {
    const root = document.documentElement; // Access :root for custom properties

    // Existing theme properties
    /*
    root.style.setProperty('--header-bg', theme.header.background);
    root.style.setProperty('--header-text', theme.header.text);
    root.style.setProperty('--footer-bg', theme.footer.background);
    root.style.setProperty('--footer-text', theme.footer.text);
    root.style.setProperty('--entity-bg', theme.entity.background);
    root.style.setProperty('--entity-text', theme.entity.text);
    root.style.setProperty('--entity-icon', theme.entity.icon);
    root.style.setProperty('--patient-bg', theme.patient.background);
    root.style.setProperty('--patient-text', theme.patient.text);
    root.style.setProperty('--patient-icon', theme.patient.icon);
    root.style.setProperty('--results-bg', theme.results.background);
    root.style.setProperty('--results-text', theme.results.text);
    root.style.setProperty('--results-icon', theme.results.icon);
    root.style.setProperty('--language-switch-bg', theme.languageSwitch.background);
    root.style.setProperty('--language-switch-text', theme.languageSwitch.text);
    root.style.setProperty('--language-switch-hover-bg', theme.languageSwitch.hoverBackground);
    root.style.setProperty('--pdf-preview-bg', theme.pdfPreview.modalBackground);
    root.style.setProperty('--pdf-preview-header-text', theme.pdfPreview.headerText);
*/
    // New login theme properties
    console.log("aplicando theme");
    root.style.setProperty('--login-container-bg', theme.login.containerBackground);
    root.style.setProperty('--login-card-bg', theme.login.cardBackground);
    root.style.setProperty('--login-card-text', theme.login.cardText);
    root.style.setProperty('--login-button-bg', theme.login.buttonBackground);
    root.style.setProperty('--login-button-text', theme.login.buttonText);
    root.style.setProperty('--login-button-hover-bg', theme.login.buttonHoverBackground);
    root.style.setProperty('--login-icon', theme.login.icon);
  }
  //}

  isWhatsAppBrowserBKold(): boolean {
    //const ua = navigator.userAgent.toLowerCase();
    return this.ua.includes("whatsapp");
  }

  isWhatsAppBrowserx(): boolean {
  const w = window as any;
  const uaRaw = navigator.userAgent;
  const ua = (uaRaw || "").toLowerCase();
  const ref = (document.referrer || "").toLowerCase();

  // 1) Señal fuerte: ReactNativeWebView presente (WhatsApp usa RN WebView fork)
  if (w.ReactNativeWebView) {
    // Si además el referrer contiene whatsapp o el UA contiene 'wv' lo confirmamos
    if (ref.includes("whatsapp") || ua.includes("wv") || ua.includes("whatsapp")) return true;
    // Si UA está vacío pero hay ReactNativeWebView, es muy probable que sea una app webview (incluye WhatsApp)
    if (!ua) return true;
  }

  // 2) Referrer que apunta a whatsapp (ej: desde chat o grupos)
  if (ref.includes("chat.whatsapp.com") || ref.includes("whatsapp.com")) return true;

  // 3) Indicadores en el UA (cuando no está vacío)
  if (ua.includes("whatsapp") || ua.includes("wv") || ua.includes("androidwebview")) return true;

  // 4) Heurística de WebView (sin vendor, sin chrome en UA pero con touch) — posible webview
  const isProbablyWebView = !/chrome|safari|firefox/i.test(ua) && !!("ontouchstart" in window);
  if (isProbablyWebView && (ua === "" || ua.includes("mobile"))) {
    // esto puede ser webview genérico; no afirmamos WhatsApp a menos que haya otra pista
    // devolvemos false aquí para evitar false positives
    return false;
  }

  return false;
}

 isWhatsAppBrowserBK(): boolean {
  const ua = navigator.userAgent || "";
  const appVersion = navigator.appVersion || "";

  // WhatsApp siempre inyecta "[WA4A/..." en Android
  return /\[WA\dA\/[^\]]+\]/i.test(ua) || /\[WA\dA\/[^\]]+\]/i.test(appVersion);
}

isWhatsAppBrowser(): boolean {
  const ua = navigator.userAgent || "";
  const appVersion = navigator.appVersion || "";

  // WhatsApp Android → firma: [WA4A/...], [WA3A/...], etc.
  const isWhatsAppAndroid = /\[WA\dA\/[^\]]+\]/i.test(ua) || /\[WA\dA\/[^\]]+\]/i.test(appVersion);

  // WhatsApp iOS → firma: [WAiOS/...], WAWebView o WhatsApp en UA
  const isWhatsAppIOS = /WAiOS|WAWebView|WhatsApp/i.test(ua);

  return isWhatsAppAndroid || isWhatsAppIOS;
}





test(){
  //navigator.vendor
  return this.navigatorToJSON();
}

 navigatorToJSON(): string {
  const output: any = {};

  for (const key in navigator) {
    try {
      const value = (navigator as any)[key];
      if (typeof value !== "function") {
        output[key] = value;
      }
    } catch (_) {console.log(_);}
  }

  return JSON.stringify(output, null, 2);
}



  isAndroid(): boolean {
  const ua = navigator.userAgent || "";
  const av = navigator.appVersion || "";
  const platform = navigator.platform || "";
  const uaData = (navigator as any).userAgentData;

  return (
    /android/i.test(ua) ||
    /android/i.test(av) ||
    /android/i.test(platform) ||
    (uaData && /android/i.test(uaData.platform))
  );
}


    isIOS (): boolean{   
    return /iphone|ipad|ipod/.test(this.ua);
  }

  isPageTest(){
    return window.location.href.includes("N65JDH9F");
  }
  openInExternalBrowserBK() {
      window.open(window.location.href, "_blank");
    }

    openInExternalBrowser() {
  const url = new URL(window.location.href);
  url.searchParams.set("reload", Date.now().toString());
  window.location.href = url.toString();
}

getUrl(){
   const url = new URL(window.location.href);
  //url.searchParams.set("reload", Date.now().toString());
  return url.toString();
}


 openChromeIntent() {
  const url = window.location.href;
  const cleanUrl = url.replace(/^https?:\/\//, '');

  const intentUrl =
    `intent://${cleanUrl}` +
    `#Intent;scheme=https;package=com.android.chrome;end;`;

  // Primero intent
  window.location.href = intentUrl;

  // Fallback si Chrome no existe → abrir navegador por defecto
  setTimeout(() => {
    window.location.href = url;
  }, 800);
}


  mounted() {
    /*
    console.log(this.ua)
    if(this.isWhatsAppBrowser() && this.isAndroid()){
      ///this.openChromeIntent();
      this. openInExternalBrowser();
    }*/

     if(this.isWhatsAppBrowser() && this.isAndroid()){
      this.openChromeIntent();
      //this. openInExternalBrowser();
    }

    sessionStorage.removeItem("visitData");
    this.getConfig();
    this.setBirthMonthDays();
    this.setBirthYears();
  }
}
